import { render, staticRenderFns } from "./Wp_mini_member_active_value_detail.vue?vue&type=template&id=540c511a&scoped=true&"
import script from "./Wp_mini_member_active_value_detail.vue?vue&type=script&lang=js&"
export * from "./Wp_mini_member_active_value_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c511a",
  null
  
)

export default component.exports